import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocatorService {
    public deleteModalVisible = signal(false);
    public territoryToDelete = signal<string | null>(null);

    openDeleteModal(territoryName: string): void {
        this.territoryToDelete.set(territoryName);
        this.deleteModalVisible.set(true);
    }

    closeDeleteModal(): void {
        this.deleteModalVisible.set(false);
        this.territoryToDelete.set(null);
    }
}
